import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Field, Form, Formik } from "formik";
import { bool, shape } from "prop-types";

import * as i18n from "util/i18n";
import * as Yup from "yup";
import useSchema from "hooks/useSchema";

import { routerActions } from "connected-react-router";
import { actions as cedipActions } from "reducers/cedip";
import { actions as accountsActions } from "reducers/accounts";

import Selector from "pages/_components/fields/formik/Selector";
// import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";
import Drawer from "pages/_components/Drawer/Drawer";
import Notification from "pages/_components/Notification";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import { stateActivePendient } from "util/cedip";
import GridTable from "pages/_components/GridTable/GridTable";

import I18n from "pages/_components/I18n";
import SideBarCedipForm from "../components/SideBarCedipForm";
import handleClickAcceptAction from "../../ManagementCedip/hooks/handleClickAcceptAction";

const FORM_ID = "cedip.admit";

const AdmitCedip = (props) => {
    const { match, isDesktop } = props;
    const dispatch = useDispatch();
    const [openSidebar, setOpenSidebar] = useState(false);
    const { cedipList } = useSelector((state) => state.cedip);
    const { accounts } = useSelector((state) => state.accounts);
    const { cedipsLength = cedipList.length, selectedCedip, transmitCedipData } = useSelector((state) => state.cedip);
    const { stringRequired } = useSchema();
    useEffect(() => {
        dispatch(accountsActions.listAccountsCbu());
    }, []);

    useEffect(() => {
        if (!cedipsLength) {
            const receivedCedipFilters = {
                createdFrom: null,
                createdTo: null,
                expiredFrom: null,
                expiredTo: null,
                cedipId: match.params.id,
                status: stateActivePendient,
                pageNumber: 1,
            };
            dispatch(cedipActions.filterCedipList({ ...receivedCedipFilters }));
        }
        dispatch(cedipActions.readCedip(match.params.id));
        dispatch(cedipActions.setTransmitCedip({}));
    }, [cedipsLength, match.params.id]);

    const placeholder = i18n.get("global.select");

    const initialValues = {
        cbu: "",
        newCbu: "",
    };

    const accountOptions = accounts?.map((data) => ({
        value: data?.cbu?.substring(9),
        label: data?.cbu?.substring(9),
    }));
    // accountOptions.unshift({ value: "otra", label: "Otra" });

    const cbuOptions = accounts ? accountOptions : [];

    const handleSubmit = (values) => {
        const cbu = values.cbu === "otra" ? values.newCbu : values.cbu;
        setOpenSidebar(true);

        dispatch(cedipActions.setCedipAction("CEDIP-TRANSMIT-ADMIT"));

        dispatch(
            cedipActions.setTransmitCedip({
                ...selectedCedip,
                cbuAcreditarSelected: cbu,
            }),
        );
    };

    const transmitCedipValidation = Yup.lazy((values) => {
        let validate;
        if (values.cbu === "otra") {
            validate = {
                cbu: stringRequired,
                newCbu: stringRequired,
            };
        } else {
            validate = {
                cbu: stringRequired,
            };
        }

        return Yup.object().shape(validate);
    });

    return (
        <>
            <Notification scopeToShow="cedip/admit" />
            <ResponsiveHeader id="cedip.item.option4" />
            <MainContainer classname="cedip">
                {isDesktop && (
                    <div className="acct-number">
                        <I18n id="cedip.transmit.admit.subtitle" />
                    </div>
                )}
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    validationSchema={transmitCedipValidation}
                    validateOnChange>
                    {({ values }) => (
                        <Form>
                            <GridTable className="form">
                                <GridTable.Container columns={12} columnsTemplate="fixed">
                                    <GridTable.Data className="required" columnStart={2} columnWidth={10}>
                                        {/* <Field
                                            component={ProductSelector}
                                            idForm={FORM_ID}
                                            name="idAccount"
                                            label={`${i18n.get("cedip.transmit.account.label")}`}
                                            placeholder={placeholder}
                                            data={{ emptyOptionLabel: "", options: accountOptions }}
                                            onChange={(id) => setSelectedAccountId(id)}
                                        /> */}
                                        <Field
                                            component={Selector}
                                            idForm={FORM_ID}
                                            name="cbu"
                                            options={cbuOptions}
                                            placeholder={placeholder}
                                        />
                                    </GridTable.Data>
                                    {/* {values.cbu === "otra" && (
                                        <GridTable.Data className="required" columnStart={2} columnWidth={10}>
                                            <Field
                                                component={TextField}
                                                idForm={FORM_ID}
                                                name="newCbu"
                                                pattern="[0-9]*"
                                                type="text"
                                                maxLength="150"
                                                hidePlaceholder
                                            />
                                        </GridTable.Data>
                                    )} */}
                                </GridTable.Container>
                            </GridTable>
                            <GridTable>
                                <GridTable.Container columns={12} columnsTemplate="fixed" className="form-actions">
                                    <GridTable.Data columnStart={2} columnWidth={4}>
                                        <Button
                                            className="btn btn-outline btn-block"
                                            label="global.cancel"
                                            onClick={() => dispatch(routerActions.push("/depositsCedip"))}
                                            block
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={8} columnWidth={4}>
                                        <Button
                                            type="submit"
                                            className="btn-primary"
                                            label="global.continue"
                                            disabled={
                                                values.cbu === "otra" ? !values.cbu || !values.newCbu : !values.cbu
                                            }
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
            <Drawer openSidebar={openSidebar} toggleSidebar={setOpenSidebar}>
                <SideBarCedipForm
                    idAccion="transmit.admit"
                    handleCancel={() => setOpenSidebar(false)}
                    handleAccept={() => handleClickAcceptAction("transmit.admit", transmitCedipData, dispatch)}
                />
            </Drawer>
        </>
    );
};

AdmitCedip.propTypes = {
    match: shape().isRequired,
    isDesktop: bool.isRequired,
};

export default AdmitCedip;
